<template>
    <div>
        <DCard
            padding
        >
            <DForm @submit.prevent>
                <div class="code-textarea-container">
                    <DRow>
                        <DCol col="7">
                            <DFormRow
                                class="mb-4"
                                is-vertical
                                :label="__('tools.emails.footer_legal_info.language')"
                                is-required
                                :error="validationErrors['language_code']"
                            >
                                <DInput
                                    :value="legalInfo.language.text"
                                    disabled
                                />
                            </DFormRow>
                            <DFormRow
                                class="mb-4"
                                is-vertical
                                :label="__('tools.emails.footer_legal_info.editor')"
                                is-required
                                :error="validationErrors['template.legal_info']"
                            >
                                <DFormTextarea
                                    id="legal_info"
                                    v-model="form.legal_info"
                                    rows="15"
                                />
                            </DFormRow>
                            <PreviewText
                                :content="form.legal_info"
                                :email-type="emailType"
                            />
                        </DCol>
                        <DCol col="5">
                            <h2 class="h5">
                                {{ __('tools.emails.footer_legal_info.legend') }}
                            </h2>
                            <EmailPlaceholders :placeholders="placeholders" />
                        </DCol>
                    </DRow>
                </div>
            </DForm>
            <EmailEditPreviewModal
                :show-modal="showPreviewModal"
                :brands="brands"
                :mailables="mailables"
                :form="form"
                :preview-route="previewRoute"
                :content-update-route="contentUpdateRoute"
                @closeModal="showPreviewModal=false"
                @modalError="handleModalError"
            />
            <DFabs>
                <DFab
                    id="btn-save"
                    icon="eye"
                    :label="__('messages.preview')"
                    @click="handlePreview"
                />
            </DFabs>
        </DCard>
    </div>
</template>

<script>

import PreviewText from '~@/Components/Tools/Emails/PreviewText'
import EmailPlaceholders from '~@/Components/Tools/Emails/Placeholders'
import EmailEditPreviewModal from '~@/Components/Tools/Emails/EmailEditPreviewModal'

export default {
    name: 'LegalInfoCreate',
    components: { EmailEditPreviewModal, EmailPlaceholders, PreviewText },
    props: {
        legalInfo: {
            type: Object,
            default: () => { return {} }
        },
        placeholders: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        mailables: {
            type: Array,
            default: () => { return [] }
        },
        brands: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            saveDisabled: true,
            emailType: 'footer',
            showPreviewModal: false,
            previewRoute: this.$route('tools.emails.legal-info-preview'),
            contentUpdateRoute: this.$route('tools.emails.legal-info-update'),
            validationErrors: this.errors,
            form: this.$inertia.form({
                legal_info: this.legalInfo.content,
                language_code: this.legalInfo.language.value
            })
        }
    },
    methods: {
        handlePreview () {
            this.showPreviewModal = true
        },
        handleModalError (errorObject) {
            Object.keys(errorObject).forEach((field) => {
                errorObject[field].forEach((message) => {
                    this.validationErrors[field] = message
                })
            })
        }
    }
}
</script>
